type Props = {
  minBet: number;
  maxBet: number;
  renderChips: React.ReactNode;
};

const ChipsPanel = ({ minBet, maxBet, renderChips }: Props) => {
  return (
    <div className="chips">
      <div className="chips__header">
        <p>Choose Chips:</p>
        <div className="chips__info">
          <p>
            Min: <span>{minBet} BUSD</span>
          </p>
          <p>
            Max: <span>{maxBet} BUSD</span>
          </p>
        </div>
      </div>
      <div className="chips__body">{renderChips}</div>
    </div>
  );
};

export default ChipsPanel;
